import { render, staticRenderFns } from "./CustomerUpdatesList.vue?vue&type=template&id=156ef653"
import script from "./CustomerUpdatesList.vue?vue&type=script&lang=js"
export * from "./CustomerUpdatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports